import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FiArrowLeft, FiPlus, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import Loader from "../../components/common/Loader";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import { toast } from "sonner";
import axios from "axios";
import { isPermission } from "../../redux/selectors/authSelector";


const AddParent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    country: "KE",
    children: [{ name: "", class: "", section: "" }],
  });
  const [refresh, setRefresh] = useState(false);
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useCountryNavigate();
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  console.log("role  dsferet", role)
  const { id } = useParams();
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");

  const dialCodes = {
    // IN: "+91",
    KE: "+254",
    UG: "+256",
  };
  const flagsContext = require.context(
    "../../assets/flags",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const getFlagImage = (code) => {
    try {
      return flagsContext(`./${code.toLowerCase()}.png`);
    } catch (e) {
      return null;
    }
  };
  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Parent name is required";
    }

    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
    }

    // Validate children
    if (formData.children.length === 0) {
      newErrors.children = "At least one child is required";
    } else {
      formData.children.forEach((child, index) => {
        if (!child.name.trim()) {
          newErrors[`child_name_${index}`] = "Child name is required";
        }
        if (!child.class.trim()) {
          newErrors[`child_class_${index}`] = "Class is required";
        }
        if (!child.section.trim()) {
          newErrors[`child_section_${index}`] = "Section is required";
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // New function to check if all children fields are filled
  const areAllChildrenFieldsFilled = () => {
    return formData.children.every(
      (child) => child.name.trim() && child.class.trim() && child.section.trim()
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "name" && !/^[A-Za-z ]*$/.test(value)) {
      return;
    }

    if (name === "mobile_number") {
      if (!/^\d*$/.test(value)) return;
    }

    // Convert email to lowercase automatically
    if (name === "email") {
      setFormData({
        ...formData,
        [name]: value.toLowerCase(),
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChildChange = (index, field, value) => {
    if (field === "name" && !/^[A-Za-z ]*$/.test(value)) {
      return;
    }

    const updatedChildren = [...formData.children];
    updatedChildren[index][field] = value;
    setFormData({
      ...formData,
      children: updatedChildren,
    });
  };

  const addChild = () => {
    // Check if all existing children have all fields filled
    if (!areAllChildrenFieldsFilled()) {
      toast.warning(
        "Please fill all fields for existing children before adding a new one"
      );
      return;
    }

    setFormData({
      ...formData,
      children: [...formData.children, { name: "", class: "", section: "" }],
    });
  };

  const removeChild = (index) => {
    if (formData.children.length === 1) {
      toast.warning("At least one child is required");
      return;
    }
    const updatedChildren = formData.children.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      children: updatedChildren,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoader(true);

    try {
      const fullMobile = dialCodes[formData.country] + formData.mobile_number;

      const payload = {
        name: formData.name,
        email: formData.email,
        mobile_number: fullMobile,
        children: JSON.stringify(formData.children),
        school_id: schoolId,
      };

      let res;

      if (params.id) {
        // UPDATE
        res = await axios.put(
          `${process.env.REACT_APP_API_URL}admin/parent-update/${params.id}`,
          payload
        );
      } else {
        // ADD
        res = await axios.post(
          `${process.env.REACT_APP_API_URL}admin/parent-add`,
          payload
        );
      }

      if (res.data?.status === 200) {
        toast.success(res.data.message);
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Parents Management" },
            });
          } else {
            navigate("navigation-dashboard", {
              state: { mainTab: "Parents Management" },
            });
          }
        } else {
          navigate("parent-management");
        }
      } else if (res.data?.status === 201) {
        // Handle validation errors from backend
        // Show inline error instead of toast
        if (res.data.message.toLowerCase().includes("email")) {
          setErrors({ ...errors, email: res.data.message });
        } else {
          toast.error(res.data.message);
        }
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      // Handle backend validation errors
      if (error.response?.data?.message) {
        if (error.response.data.message.toLowerCase().includes("email")) {
          setErrors({ ...errors, email: error.response.data.message });
        } else {
          toast.error(error.response.data.message);
        }
      } else {
        toast.error("Failed to save parent");
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!id) return;

    const fetchParent = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/parent/${id}`
        );

        if (res.data?.status === 200) {
          const fullNumber = res.data.data.mobile_number;

          let country = "KE";
          if (fullNumber.startsWith("+91")) country = "IN";
          else if (fullNumber.startsWith("+254")) country = "KE";
          else if (fullNumber.startsWith("+256")) country = "UG";

          const dialCode = dialCodes[country]; // "+91", "+254", "+256"

          setFormData({
            name: res.data.data.name,
            email: res.data.data.email,
            country,
            mobile_number: fullNumber.replace(dialCode, ""),
            children: res.data.data.children,
          });
        }
      } catch (err) {
        toast.error("Failed to fetch parent");
      }
    };

    fetchParent();
  }, [id]);

  const permissions = useSelector(isPermission);
  console.log("permissions:::::::::::::::::::::::::::::::::", permissions)
  const isAccessible =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_School"))) ||
    false;

  console.log("isAccessible::::::::::::::::::::::::::::", isAccessible)

  const handleParentNavigation = () => {
    if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin" || isAccessible) {
      if (mode === "view") {
        navigate(`admin-school/view/${schoolId}`, {
          state: { mainTab: "Parents Management" },
        });
      } else {
        navigate("navigation-dashboard", {
          state: { mainTab: "Parents Management" },
        });
      }
    } else {
      navigate("parent-management");
    }
  };

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }

  return (
    <div className="p-6 space-y-6 pr-0">
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full bg-white rounded-xl p-6">
          <div
            className="flex items-center mb-4 cursor-pointer"
            onClick={handleParentNavigation}
          >
            <FiArrowLeft className="text-2xl font-bold mb-6 text-gray-800" />
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              {params.id ? "Edit Parent" : "Add Parent"}
            </h2>
          </div>

          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
            className="space-y-5"
          >
            {/* Parent Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Parent Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter parent name"
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name}</p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email}</p>
              )}
            </div>

            {/* Mobile Number */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile Number <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
                maxLength={10}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter mobile number"
              />
              {errors.mobile_number && (
                <p className="text-red-500 text-sm">{errors.mobile_number}</p>
              )}
            </div> */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile Number <span className="text-red-500">*</span>
              </label>

              <div className="flex items-center border border-gray-300 rounded-lg px-2 py-2 gap-2">
                {/* Country Flag Selector */}
                <div className="relative flex items-center cursor-pointer">
                  <select
                    value={formData.country}
                    onChange={(e) =>
                      setFormData({ ...formData, country: e.target.value })
                    }
                    className="absolute inset-0 opacity-0 cursor-pointer"
                  >
                    <option value="KE">Kenya</option>
                    {/* <option value="IN">India</option> */}
                    <option value="UG">Uganda</option>
                  </select>

                  <img
                    src={getFlagImage(formData.country)}
                    alt="flag"
                    className="w-6 h-4"
                  />
                  <span className="ml-1 text-xs">▾</span>
                </div>

                {/* Mobile Number Input */}
                <input
                  type="tel"
                  value={formData.mobile_number}
                  onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                    setFormData({ ...formData, mobile_number: onlyNumbers });
                  }}
                  maxLength={10}
                  placeholder="Enter mobile number"
                  className="flex-1 outline-none border-0 focus:ring-0"
                />
              </div>

              {errors.mobile_number && (
                <p className="text-red-500 text-sm">{errors.mobile_number}</p>
              )}
            </div>

            {/* Children Section */}
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <label className="block text-sm font-medium text-gray-700">
                  Children Details <span className="text-red-500">*</span>
                </label>
                <button
                  type="button"
                  onClick={addChild}
                  className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600"
                >
                  <FiPlus /> Add Child
                </button>
              </div>

              {errors.children && (
                <p className="text-red-500 text-sm">{errors.children}</p>
              )}

              {formData.children.map((child, index) => (
                <div
                  key={index}
                  className="border border-gray-300 rounded-lg p-4 space-y-3 bg-gray-50"
                >
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium text-gray-700">
                      Child {index + 1}
                    </h3>
                    {formData.children.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeChild(index)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <FiTrash2 />
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Child Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={child.name}
                        onChange={(e) =>
                          handleChildChange(index, "name", e.target.value)
                        }
                        className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                        placeholder="Child name"
                      />
                      {errors[`child_name_${index}`] && (
                        <p className="text-red-500 text-sm">
                          {errors[`child_name_${index}`]}
                        </p>
                      )}
                    </div>

                    {/* Child Grade */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Grade <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={child.class}
                        onChange={(e) =>
                          handleChildChange(index, "class", e.target.value)
                        }
                        className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                        placeholder="Grade"
                      />
                      {errors[`child_class_${index}`] && (
                        <p className="text-red-500 text-sm">
                          {errors[`child_class_${index}`]}
                        </p>
                      )}
                    </div>

                    {/* Child Section */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Section <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={child.section}
                        onChange={(e) =>
                          handleChildChange(index, "section", e.target.value)
                        }
                        className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                        placeholder="Section"
                      />
                      {errors[`child_section_${index}`] && (
                        <p className="text-red-500 text-sm">
                          {errors[`child_section_${index}`]}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <div className="w-full flex justify-center gap-3 mb-2 mt-4">
              <button
                type="submit"
                className="button-field-primary"
                style={{ width: "30%" }}
                disabled={loader}
              >
                {loader ? "Please wait..." : params.id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddParent;
